import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Button,
} from "@mui/material";
import { Colors } from "design/theme";
import { DATA_TYPE_COLORS } from "modules/universe/NeuroJsonGraph";
import React, { useEffect, useState } from "react";

interface ModalitiesFilterProps {
  onFilter: (selectedModalities: string[]) => void;
  homeSelectedModalities: string[]; // add prop to receive parent state
}

const modalitiesList = ["mri", "pet", "meg", "eeg", "ieeg", "dwi", "fnirs"];

const ModalitiesFilter: React.FC<ModalitiesFilterProps> = ({
  onFilter,
  homeSelectedModalities,
}) => {
  const [selectedModalities, setSelectedModalities] = useState<string[]>(
    homeSelectedModalities
  );

  useEffect(() => {
    setSelectedModalities(homeSelectedModalities);
  }, [homeSelectedModalities]);

  const handleModalityChange = (modality: string) => {
    const updatedModalities = selectedModalities.includes(modality)
      ? selectedModalities.filter((m) => m !== modality)
      : [...selectedModalities, modality];
    setSelectedModalities(updatedModalities);
    onFilter(updatedModalities);
  };

  // reset function to clear all selected checkboxes
  const handleReset = () => {
    setSelectedModalities([]); // clear the local state
    onFilter([]); // notify parent that selection is reset
  };

  return (
    <Box>
      {modalitiesList.map((modality) => {
        const bgColor = DATA_TYPE_COLORS[modality]
          ? `rgb(${DATA_TYPE_COLORS[modality].join(",")})`
          : "transparent";
        return (
          <Box
            key={modality}
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedModalities.includes(modality)}
                  onChange={() => handleModalityChange(modality)}
                />
              }
              label={
                <Typography
                  sx={{
                    color: Colors.lightGray,
                    backgroundColor: bgColor,
                    borderRadius: "5px",
                    padding: "5px",
                    marginBottom: "5px",
                    fontWeight: "bold",
                    minWidth: "45px",
                    textAlign: "center",
                  }}
                >
                  {modality}
                </Typography>
              }
            />
          </Box>
        );
      })}
      {/* Reset button */}
      <Button
        variant="contained"
        sx={{
          marginTop: "10px",
          backgroundColor: Colors.white,
          color: Colors.purple,
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: Colors.darkPurple,
            color: Colors.green,
            boxShadow: `0px 0px 15px ${Colors.darkGreen}`,
          },
        }}
        onClick={handleReset}
      >
        Clear
      </Button>
    </Box>
  );
};

export default ModalitiesFilter;
